import { range, some } from 'lodash';

export abstract class KeyboardService {

  static AllowedNumericCharts = ['.', ...range(0, 10).map(i => i.toString())];

  static getMovement(e: React.KeyboardEvent) {
    switch (e.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        return -1;
      case 'ArrowRight':
      case 'ArrowDown':
        return 1;
      default:
        if (e.shiftKey && e.key === 'Tab') {
          return -1;
        } else if (e.key === 'Tab') {
          return 1;
        }

        return undefined;
    }
  }
  static isNumeralKey(e: React.KeyboardEvent) {
    if (e.ctrlKey || e.shiftKey || e.metaKey || e.altKey) {
      return false;
    }
    if (e.key.length !== 1) {
      return false;
    }
    return some(this.AllowedNumericCharts, k => k === e.key);
  }
  static isCommitKey(e: React.KeyboardEvent) {
    return some(['Enter', 'Tab'], k => e.key === k);
  }
  static addFloatingDecimal(numeral: string | undefined) {
    if (!numeral) {
      return numeral;
    }
    if (numeral.includes('.')) {
      return numeral;
    }
    const padded = numeral.padStart(3, '0');
    const pointMarker = padded.length - 2;
    const mantissa = padded.substr(pointMarker, 2);
    const whole = padded.substr(0, pointMarker);
    const result = [whole, mantissa].join('.');
    return this.trimCurrency(result);
  }
  static trimCurrency(c: string) {
    let marker = -1;

    for (let i = 0; i < c.length; i++) {
      if (c[i] !== '0') {
        marker = i;
        break;
      }
    }

    if (marker <= -1) {
      return c;
    }
    if (c[marker] === '.') {
      marker--;
    }
    return c.substr(marker, c.length - marker);
  }
}



